export default "__VITE_ASSET__DEn3SHBg__";